import { Link } from 'react-router-dom';
import SeriesCard from '@/components/base/SeriesCard';
import { seriesList } from '@/mocks/series';

const hotList = [...seriesList].sort((a, b) => b.rating - a.rating).slice(0, 12);

export default function HotSeriesSection() {
  return (
    <section className="w-full">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-primary-500">Now Streaming</p>
            <h2 className="mt-2 font-heading text-xl font-semibold text-foreground-950 md:text-3xl">当季热播剧集</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-500">
              精选评分最高的热门电视剧，高清剧集持续更新，点击卡片查看剧情与演员信息。
            </p>
          </div>
          <Link
            to="/category"
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部剧集
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-5 xl:grid-cols-6">
          {hotList.map((series, position) => (
            <SeriesCard key={series.id} series={series} rank={position + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}